import React, { useEffect, useState } from 'react'
import { Card, Modal } from 'react-bootstrap'
import { changeTextCapital } from '../../../../_metronic/helpers'
import { useAuth } from '../../../modules/auth'
//import { getAssetsByUserId, getAssetsByUserIdforProfile } from '../../../../api/AssetsAPI'
import { toast } from 'react-toastify'
import { useParams } from 'react-router-dom'
import { Center } from '@mantine/core'
import { truncateString } from '../../attendance/ams'
import { getAdminAssets, getAssetsByUserIdforProfile, getAssetsByUserId, getAllUserAssets } from '../../../../api/AssetsAPI'
import { acknowledgeUserAsset } from '../../../../api/AssetsAPI'
import { useContext } from 'react'
import roleContext from '../../../context/roleContext'
import { RoleContextValue } from '../../../types/OtherTypes'

interface IUserAsset {
  id: string
  location: string
  // isAcknowledged: boolean
  acknowledged: boolean
  locationType: string
  issueDate: string
  returnDate: string | null
  createdAt: string
  updatedAt: string
  asset: {
    id: string
    assetTag: string
    brand: string
    serialNo: string
    purchaseDate: string
    description: string
    createdAt: string
    updatedAt: string
    status: string
    category: string
    subCategory: string
    location: string
    locationType: string
    comment: string | null
  }
}

interface IUser {
  id: string
  firstName: string
  lastName: string
  userAssets: IUserAsset[]
}

const Possesion = () => {
  const { currentUser } = useAuth()
  const [user, setUser] = useState<IUser | null>(null)
  const [APIStatus, setAPIStatus] = useState({
    loading: false,
    error: null,
    submitLoading: false,
  })
  const [assets, setAssets] = useState<IUserAsset[]>([])
  const [reasonModalOpen, setReasonModalOpen] = useState(false)
  //Search 1)
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedReason, setSelectedReason] = useState('')
  const params = useParams()
  const userId = params.id ?? (currentUser?.id || '')
  const isOwnProfile = currentUser?.id === userId
  
  //----------------------------------------------------
  //Role which employee show acknowlege button
  let roleState: RoleContextValue = useContext(roleContext)
  const roleName = roleState.roleName?.trim().toLowerCase()
  const isAdmin = roleName === 'admin'
  const isSuperAdmin = roleName === 'super admin'
  // Employee = NOT admin & NOT super admin
  const isEmployee = !isAdmin && !isSuperAdmin
  //----------------------------------------------------
  //Read More Button or LessMore Button
  const [expandedRows, setExpandedRows] = useState<string[]>([])
  const toggleDescription = (id: string) => {
    setExpandedRows(prev =>
      prev.includes(id)
        ? prev.filter(item => item !== id)
        : [...prev, id]
    )
  }

  //Assets Button was Hide After CClicking Acknowlege 
    const handleAcknowledge = async (userAssetId: string) => {
      if (!currentUser) return

      setAPIStatus(prev => ({ ...prev, submitLoading: true }))

      try {
        const response = await acknowledgeUserAsset(userAssetId)

        if (response.statusCode === 200) {
          toast.success('Asset acknowledged successfully')

          setAssets(prev =>
            prev.map(asset =>
              asset.id === userAssetId
                ? { ...asset, acknowledged: true }
                : asset
            )
          )
        }

        //  IMPORTANT FIX
        else if (
          response.message === "Asset already acknowledged"
        ) {
          toast.info("Asset already acknowledged")

          // Force UI to update
          setAssets(prev =>
            prev.map(asset =>
              asset.id === userAssetId
                ? { ...asset, acknowledged: true }
                : asset
            )
          )
        }

        else {
          toast.error(response.message || 'Failed to acknowledge asset')
        }

      } catch (err) {
        toast.error('Something went wrong')
      } finally {
        setAPIStatus(prev => ({ ...prev, submitLoading: false }))
      }
    }



  const fetchUserById = () => {
    if (!currentUser || !userId) return

    setAPIStatus({ ...APIStatus, loading: true })
    const roleName = currentUser?.role?.name?.trim().toLowerCase() || ''
    const isAdminOrIT =
    roleName.includes('admin') 


    const apiCall = isAdminOrIT
      ? getAllUserAssets()                  // ADMIN → ALL ASSETS
      : getAssetsByUserIdforProfile(userId) // USER → OWN ASSETS

    apiCall.then((response) => {
      console.log('PROFILE ASSET API RESPONSE:', response)

      if (response?.statusCode === 200) {
        setAssets(Array.isArray(response.data) ? response.data : [])
      } else {
        setAssets([])
      }

      setAPIStatus({ ...APIStatus, loading: false })
    })
  }

  useEffect(() => {
    fetchUserById()
  }, [currentUser, userId])


  // useEffect(() => {
  //   fetchUserById()
  // }, [])
  
  //Search 1
  const filteredAssets = assets.filter((item) => {
  const category = item.asset?.category ?? ''
  const brand = item.asset?.brand ?? ''
  const serialNo = item.asset?.serialNo ?? ''

  // Create same format as UI shows
  const fullAssetTag = `${category} - ${brand}`.toLowerCase()

  const search = searchTerm.toLowerCase()

    return (
      fullAssetTag.includes(search) ||
      serialNo.toLowerCase().includes(search)
    )
  })

  return (

    <>  <Modal
      show={reasonModalOpen}
      onClose={() => setReasonModalOpen(false)}
      animation={false}
      backdrop='static'
      centered
    >
      <div className='modal-header'>
        <h2 className='fw-bolder'>Description</h2>
        <div
          className='btn btn-icon btn-sm btn-active-icon-danger'
          data-kt-users-modal-action='close'
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setReasonModalOpen(false)
          }}
        >
          <i className='fa-solid fa-xmark fs-1' />
        </div>
      </div>
      <div className='card-body'>
        <div className='mt-5 ms-5 mb-5' dangerouslySetInnerHTML={{ __html: selectedReason }} />
      </div>
    </Modal>
      <div className='row g-5 g-xl-8'>
        <div className='col-xl-12'>
          <div className='card card-xl-stretch mb-xl-8'>
            <div className='card-header'>
              <div className='card-title'>Asset Details</div>
            </div>
            {/* Search 1 */}
            <div className='card-body'>
              <div className='mb-4' style={{ maxWidth: '300px' }}>
              <div className='input-group'>
                <span className='input-group-text bg-white'>
                  <i className='fa fa-search text-muted'></i>
                </span>
                <input
                  type='text'
                  className='form-control'
                  placeholder='Search by Asset Tag or Serial No...'
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-bordered'>
                  <thead>
                    <tr className='fw-bold text-muted'>
                      <th className='pl-1 text-center' style={{ minWidth: '80px' }}>
                        {changeTextCapital('Sr.No')}
                      </th>
                      <th className='pl-1 text-center' style={{ minWidth: '80px' }}>
                        {changeTextCapital('Asset Tag')}
                      </th>
                      <th className='pl-1 text-center' style={{ minWidth: '150px' }}>
                        {changeTextCapital('Serial No')}
                      </th>
                      <th className='pl-1 text-center' style={{ minWidth: '120px' }}>
                        {changeTextCapital('Description')}
                      </th>
                      <th className='pl-1 text-center' style={{ minWidth: '120px' }}>
                        {changeTextCapital('Location')}
                      </th>
                      <th className='pl-1 text-center' style={{ minWidth: '100px' }}>
                        {changeTextCapital('Issue Date')}
                      </th>
                      <th className='pl-1 text-center' style={{ minWidth: '100px' }}>
                        {changeTextCapital('Return Date')}
                      </th>
                      {/* <th className='pl-1 text-center' style={{ minWidth: '120px' }}>
                        Actions
                      </th> */}
                      <th className='pl-1 text-center' style={{ minWidth: '120px' }}>
                        {isAdmin || isSuperAdmin ? 'Status' : 'Actions'}
                      </th>

                    </tr>
                  </thead>
                  {/* {assets.length > 0 ? ( */}
                  {filteredAssets.length > 0 ? (
                    <tbody className='text-gray-800 fw-semibold text-left'>
                      {/* {assets.map((asset, index) => ( */}
                      {filteredAssets.map((asset, index) => (
                        <tr key={asset.id}>
                          <td className='text-center'>{index + 1}</td>

                          {/* ASSET TAG */}
                          <td className='text-center'>
                            {asset?.asset?.category ?? '-'} - {asset?.asset?.brand ?? '-'}

                          </td>

                          {/* SERIAL NO */}
                          <td className='text-center'>
                            {asset?.asset?.serialNo ?? '-'}
                          </td>

                          {/* DESCRIPTION */}
                          {/* <td
                            className='text-center cursor-pointer'
                            onClick={() => {
                              setSelectedReason(asset?.asset?.description ?? '-')
                              setReasonModalOpen(true)
                            }}
                          >
                            {truncateString(asset?.asset?.description ?? '-', 5)}
                          </td> */}
                          <td
                            className="text-center"
                            style={{
                              maxWidth: '300px',
                              textAlign: 'justify',   
                              lineHeight: '1.7',      
                              fontSize: '14px',
                              wordBreak: 'break-word',
                              whiteSpace: 'pre-line'
                            }}
                          >
                            {asset?.asset?.description ? (() => {
                              const words = asset.asset.description.split(' ')
                              const isExpanded = expandedRows.includes(asset.id)
                              const shortText = words.slice(0, 7).join(' ')
                              const isLong = words.length > 7

                              return (
                                <>
                                  {isExpanded ? asset.asset.description : shortText}
                                  {!isExpanded && isLong && '...'}
                                  {isLong && (
                                    <span
                                      style={{
                                        color: '#0d6efd',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        marginLeft: '5px'
                                      }}
                                      onClick={() => toggleDescription(asset.id)}
                                    >
                                      {isExpanded ? 'Read Less' : 'Read More'}
                                    </span>
                                  )}
                                </>
                              )
                            })() : '-'}
                          </td>

                          {/* LOCATION */}
                          <td className='text-center'>
                            {asset?.locationType && asset?.location
                              ? `${asset.locationType} - ${asset.location}`
                              : '-'}
                          </td>

                          {/* ISSUE DATE */}
                          <td className='text-center'>
                            {asset?.issueDate
                              ? new Date(asset.issueDate).toLocaleDateString('en-GB', {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                            })
                          : '-'}
                          </td>
                          {/* RETURN DATE */}
                          <td className="text-center">
                            {asset?.returnDate
                              ? new Date(asset.returnDate).toLocaleDateString('en-GB', {
                                  year: 'numeric',
                                  month: '2-digit',
                                  day: '2-digit',
                                })
                              : '-'}
                          </td>
                          {/* <td className='text-center'>
                            {asset.returnDate ? (
                              <span className='badge bg-warning text-dark'>
                                Returned
                              </span>

                            ) : asset.acknowledged ? (
                              <button
                                className='btn btn-sm btn-success'
                                disabled
                              >
                                Acknowledged
                              </button>
                            ) : isOwnProfile ? (
                              <button
                                className='btn btn-sm btn-primary'
                                onClick={() => handleAcknowledge(asset.id)}
                              >
                                Acknowledge
                              </button>
                            ) : (
                              <span className='text-muted'>-</span>
                            )}
                          </td> */}
                          <td className='text-center'>
                            {(isAdmin || isSuperAdmin) ? (

                              asset.returnDate ? (
                                // <span className='badge bg-warning text-dark'>
                                <span>
                                  Returned
                                </span>
                              ) : asset.acknowledged ? (
                                // <span className='badge bg-success'>
                                <span>
                                  Acknowledged
                                </span>
                              ) : (
                                <span></span>   // No Pending shown
                              )
                            ) : (
                              // asset.returnDate ? (
                              //   <span></span>   // Blank if returned
                              // ) : asset.acknowledged ? (
                              //   <button
                              //     // className='btn btn-sm btn-success'
                              //     disabled
                              //   >
                              //     Acknowledged
                              //   </button>
                              // ) : (
                              //   <button
                              //     className='btn btn-sm btn-primary'
                              //     onClick={() => handleAcknowledge(asset.id)}
                              //   >
                              //     Acknowledge
                              //   </button>
                              // )
                              asset.returnDate ? (
                                <span></span>   // Blank if returned
                              ) : asset.acknowledged ? (
                                <span></span>   // Just normal text
                              ) : (
                                <button
                                  className='btn btn-sm btn-primary'
                                  onClick={() => handleAcknowledge(asset.id)}
                                >
                                  Acknowledge
                                </button>
                              )
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={7}>
                          <Center>No Record Available.</Center>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Possesion
